"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyComment = exports.TypographyInfo = exports.ItemWrapper = void 0;
const material_1 = require("@mui/material");
exports.ItemWrapper = (0, material_1.styled)(material_1.Box)(({ theme }) => ({
    backgroundColor: theme.palette['tsGoColor'].white,
    borderRadius: '3px',
    border: `1px solid ${theme.palette['tsGoColor'].grayLight()}`,
    display: 'flex',
    padding: `${theme.tsGoUnit.tsUnitHalf} ${theme.tsGoUnit.tsUnitHalf} ${theme.tsGoUnit.tsUnitQuarter} ${theme.tsGoUnit.tsUnitHalf}`,
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: theme.tsGoUnit.tsUnitQuarter,
    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
        ? {
            borderRadius: 0,
        }
        : {}),
}));
const TypographyNotice = (theme) => ({
    fontSize: theme.typography.tsFontSize.mini,
    display: 'flex',
    gap: theme.tsGoUnit.tsUnitQuarter,
    paddingBottom: theme.tsGoUnit.tsUnitHalf,
    alignItems: 'center',
});
exports.TypographyInfo = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    ...TypographyNotice(theme),
    color: theme.palette.tsGoColor.yellowDarker,
}));
exports.TypographyComment = (0, material_1.styled)(material_1.Typography)(({ theme }) => ({
    ...TypographyNotice(theme),
    color: theme.palette.tsGoColor.grayDark,
}));
